import { render, staticRenderFns } from "./StorefrontCollections.vue?vue&type=template&id=c4f44a26&scoped=true&"
import script from "./StorefrontCollections.vue?vue&type=script&lang=js&"
export * from "./StorefrontCollections.vue?vue&type=script&lang=js&"
import style0 from "./StorefrontCollections.vue?vue&type=style&index=0&id=c4f44a26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f44a26",
  null
  
)

export default component.exports